
/**
 * 受伤部位
 */

export const InjurySiteList=[
    {
        prop:"code",
        label:"代码",
        width:"150",
        isShow:false
    },
    {
        prop:"name",
        label:"名称",
        width:"150",
        isShow:true
    },
    // {
    //     prop:"siteTypeTxt",
    //     label:"分类",
    //     width:"150",
    //     isShow:true
    // },
    {
        prop:"describe",
        label:"简述",
        width:"150",
        isShow:true
    }
 ]

 export const InjurySiteType=[
    {
        id:1,
        txt:'膝盖',
        value:"Knee",
    },
    {
        id:2,
        txt:'肩部',
        value:"Shoulder",
    },
    {
        id:3,
        txt:'脚踝',
        value:"Ankle",
    },
    {
        id:4,
        txt:'肘部',
        value:"Elbow",
    },
    {
        id:5,
        txt:'肌肉',
        value:"Muscle",
    },
    {
        id:6,
        txt:'腰部',
        value:"Waist",
    },
    {
        id:7,
        txt:'胫骨',
        value:"Tibia",
    },
    {
        id:8,
        txt:'腹股沟',
        value:"Groin",
    },
    {
        id:9,
        txt:'脑部',
        value:"Cerebral",
    },
    {
        id:10,
        txt:'跟腱',
        value:"HeelTendon",
    }
 ]
